import React from 'react';
import { HereYourPlans } from '@features/onboarding/components/7-finish/HereYourPlans';

export const CoverageReassurance = ({ isChangePlan } : { isChangePlan?: boolean }) => {
  return (
    <HereYourPlans
      isChangePlan={isChangePlan}
    />
  );
};
